import type { ReactNode } from 'react'
import { AlertCircle, CheckCircle2, Info, TriangleAlert } from 'lucide-react'
import { cn } from '../lib/cn.js'

export type AlertTone = 'info' | 'success' | 'warning' | 'danger'

const config: Record<AlertTone, { cls: string; Icon: typeof Info }> = {
  info: { cls: 'bg-info-subtle text-info border-info/25', Icon: Info },
  success: { cls: 'bg-success-subtle text-success border-success/25', Icon: CheckCircle2 },
  warning: { cls: 'bg-warning-subtle text-warning border-warning/25', Icon: TriangleAlert },
  danger: { cls: 'bg-danger-subtle text-danger border-danger/25', Icon: AlertCircle },
}

export function Alert({ tone = 'info', title, children, className }: {
  tone?: AlertTone; title?: ReactNode; children?: ReactNode; className?: string
}) {
  const { cls, Icon } = config[tone]
  return (
    <div role={tone === 'danger' ? 'alert' : 'status'} className={cn('flex gap-3 rounded-lg border px-4 py-3 text-sm', cls, className)}>
      <Icon className="size-5 shrink-0 mt-0.5" aria-hidden />
      <div className="min-w-0 flex-1">
        {title && <p className="font-semibold">{title}</p>}
        {children && <div className={cn('text-fg', title && 'mt-0.5')}>{children}</div>}
      </div>
    </div>
  )
}
